<template>
  <div class="container">
    <div class="row">
      <div class="logo">
        <img src="monorevo_logo_fix-black.svg" />
      </div>
    </div>
    <div class="row">
      <div class="card mb-3 w-100">
        <div class="card-header">
          <h4>{{ $t("リセット完了")}}</h4>
        </div>
        <div class="card-body">
          <div class="form-group" style="font-size: 1.6rem; text-align: center;">
            {{ $t("パスワードが変更されました") }}
          </div>
          <div class="form-group" style="margin: 30px auto;">
            <button type="button" class="btn btn-lg btn-light btn-block" @click="onClickCancel">
              {{ $t("メニューへ") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lostpassword-done',
  data() {
    return {
      pageTitle: 'パスワードリセット 完了',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    onClickCancel() {
       window.location.href = this.$appConfig.ScreenUrl.settingMenu
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/common-page.scss";
</style>
